import React, { useState, useEffect } from "react";
import "../../../components/Styles/FirstPage.css";
import "../../../components/Styles/FormStyle.css";
import swal from "sweetalert";
import Select from "react-select";
import { banks } from "../data";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker, { registerLocale } from "react-datepicker";
import SecondDetailPage from "./SecondDetailPage";
import ReactPlayer from "react-player";
import pl from "date-fns/locale/pl"; // the locale you want
registerLocale("pl", pl); // register it with the name you want

const FirstPage = (props) => {
  const [loading, setLoading] = useState(true);
  const [creditBank, setCreditBank] = useState("");
  const [creditAmmount, setCreditAmmount] = useState("0");
  const [creditDate, setCreditDate] = useState("2015-05-05");
  const [creditCurrency, setCreditCurrency] = useState("PLN");
  const [creditMargin, setCreditMargin] = useState(7);
  const [bankOptions, setBankOptions] = useState([]);
  const [creditLength, setCreditLength] = useState(120);
  const [creditComission, setCreditComission] = useState(5000);
  const [showDetails, setShowDetails] = useState(false);

  const [blog, setBlog] = useState([]);

  const closeDetail = () => {
    setShowDetails(false);
  };

  const fetchBlog = async () => {
    await fetch(`https://twojeskd.pl/wp-json/wp/v2/posts?per_page=100`)
      .then((response) => response.json())
      .then((data) => {
        fetchBlogMedia(data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const fetchBlogMedia = async (posts) => {
    await fetch(`https://twojeskd.pl/wp-json/wp/v2/media?per_page=100`)
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        posts.forEach((post) => {
          var newR = {
            date: post.date,
            description: post.description,
            link: post.link,
            title: post.title,
            content: post.content.rendered,
            linkMedia:
              data.filter((el) => el.id === post.featured_media).length > 0
                ? data.filter((el) => el.id === post.featured_media)[0]
                    .source_url
                : "",
          };
          arr.push(newR);
        });
        setBlog(arr);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    var arr = [];
    banks.map((el) => {
      arr.push({ label: el.name, value: el.name });
    });
    setBankOptions(arr);
    setCreditBank(banks[0].name);
    fetchBlog();
  }, []);

  const focus = (e) => {
    if (e.target.value === "0") {
      if (e.target.name === "creditAmmount") {
        setCreditAmmount("0");
      }
    }
    e.target.select();
  };

  const checkDigit = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const validateForm = () => {
    if (
      !creditBank ||
      !creditAmmount ||
      !creditDate ||
      !creditMargin ||
      !creditLength
    ) {
      return false;
    } else {
      props.setCreditData({
        creditBank: creditBank,
        creditAmmount: creditAmmount,
        creditDate: creditDate,
        creditLength: creditLength,
        creditMargin: creditMargin,
        creditComission: creditComission,
      });
      return true;
    }
  };

  const submitFirstForm = (e) => {
    if (validateForm()) {
      setShowDetails(true);
    } else {
      swal({
        icon: "error",
        text: `Należy uzupełnić wymagane pola formularza!`,
        button: {
          text: "Ok",
        },
      });
    }
  };

  const decodeHtml = (html) => {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  const destkop = (
    <>
      <div style={{ display: "flex", gap: "20px" }}>
        <div className="formContainerFirst" style={{ width: "60%" }}>
          <div className="rowFirst" style={{ marginTop: "1vh" }}>
            <div className="oneColFirst">
              <div id="twoCol_columnFirst_title" className="twoCol_columnFirst">
                <label>
                  Wybierz bank, w którym masz zobowiązanie
                  <span className="requiredStar">*</span>
                </label>
              </div>
              <div id="oneColFirst_column" className="twoCol_columnFirst">
                <Select
                  className="currencySelect"
                  value={creditBank}
                  onChange={(e) => {
                    setCreditBank(e.value);
                  }}
                  options={bankOptions}
                  placeholder={creditBank ? creditBank : "Wybierz z listy..."}
                />
              </div>
              <div
                className="rowFirst"
                style={{
                  marginTop: "1vh",
                  width: "100%",
                  display: "flex",
                  gap: "20px",
                  boxSizing: "border-box",
                }}
              >
                <div id="oneColFirst_column" style={{ width: "100%" }}>
                  <label>
                    Kwota zobowiązania
                    <span className="requiredStar">*</span>
                  </label>
                  <input
                    type="number"
                    id="creditAmmount"
                    name="creditAmmount"
                    placeholder="150000"
                    onFocus={focus}
                    value={creditAmmount}
                    onChange={(e) => {
                      if (creditAmmount === 0) {
                        window.gtag("event", "conversion", {
                          send_to: "AW-11435982333/exc0CLq8ydQaEP37jM0q",
                          value: 10.0,
                          currency: "PLN",
                        });
                      }

                      setCreditAmmount(e.target.value);
                    }}
                    onKeyPress={checkDigit}
                    style={{ width: "100%" }}
                  />
                </div>
                <div id="oneColFirst_column" style={{ width: "100%" }}>
                  <label style={{ marginBottom: "1vh" }}>
                    Data uruchomienia zobowiązania
                    <span className="requiredStar">*</span>
                  </label>
                  <div style={{ width: "100%" }}>
                    <DatePicker
                      closeOnScroll={true}
                      selected={new Date(creditDate)}
                      onChange={(e) => {
                        var date =
                          new Date(e).getFullYear() +
                          "-" +
                          (new Date(e).getMonth() + 1 < 10
                            ? "0" + (new Date(e).getMonth() + 1)
                            : new Date(e).getMonth() + 1) +
                          "-" +
                          (new Date(e).getDate() < 10
                            ? "0" + new Date(e).getDate()
                            : new Date(e).getDate());
                        setCreditDate(date);
                      }}
                      dateFormat="yyyy-MM-dd"
                    />
                  </div>
                </div>
              </div>

              <div
                className="rowFirst"
                style={{
                  marginTop: "1vh",
                  width: "100%",
                  display: "flex",
                  gap: "20px",
                  boxSizing: "border-box",
                }}
              >
                <div id="oneColFirst_column" style={{ width: "100%" }}>
                  <label>
                    Długość zobowiązania
                    <span className="requiredStar">*</span>
                  </label>
                  <input
                    type="number"
                    id="creditAmmount"
                    name="creditAmmount"
                    placeholder="150000"
                    onFocus={focus}
                    value={creditLength}
                    onChange={(e) => {
                      setCreditLength(e.target.value);
                    }}
                    onKeyPress={checkDigit}
                    style={{ width: "100%" }}
                  />
                </div>
                <div id="oneColFirst_column" style={{ width: "100%" }}>
                  <label style={{ marginBottom: "1vh" }}>
                    Marża zobowiązania
                    <span className="requiredStar">*</span>
                  </label>
                  <div style={{ width: "100%" }}>
                    <input
                      type="number"
                      id="creditAmmount"
                      name="creditAmmount"
                      placeholder="150000"
                      onFocus={focus}
                      value={creditMargin}
                      onChange={(e) => {
                        setCreditMargin(e.target.value);
                      }}
                      onKeyPress={checkDigit}
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              </div>

              <div
                className="rowFirst"
                style={{
                  marginTop: "1vh",
                  width: "100%",
                  display: "flex",
                  gap: "20px",
                  boxSizing: "border-box",
                }}
              >
                <div id="oneColFirst_column" style={{ width: "60%" }}>
                  <label>Prowizja instytucji udzielającej zobowiązania</label>
                  <input
                    type="number"
                    id="creditAmmount"
                    name="creditAmmount"
                    placeholder="150000"
                    onFocus={focus}
                    value={creditComission}
                    onChange={(e) => {
                      setCreditComission(e.target.value);
                    }}
                    onKeyPress={checkDigit}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>

              <div
                className="rowFirst"
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: "1vh",
                }}
              >
                <p style={{ margin: 0 }}>
                  Przejdź dalej, aby wygenerować analizę roszczeń oraz zobaczyć
                  oferty kancelarii dostosowane do Twojej sprawy
                </p>
              </div>

              <div className="rowFirst" style={{ textAlign: "left" }}>
                <button
                  className="submitButtonFirstPage"
                  onClick={submitFirstForm}
                  style={{
                    fontSize: "1vw",
                    fontWeight: "600",
                    width: "100%",
                    marginTop: "1vh",
                  }}
                >
                  WYGENERUJ ANALIZĘ ZOBOWIĄZANIA I PORÓWNAJ KANCELARIE
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="descContainerFirst" style={{ width: "40%" }}>
          <div className="row">
            <p
              style={{
                margin: "0",
                paddingBottom: "10px",
                fontWeight: "600",
                fontSize: ".8vw",
                textTransform: "uppercase",
                width: "100%",
              }}
            >
              Taki widok zobaczysz po przejściu dalej
            </p>
            <div>
              <ReactPlayer
                width="100%"
                height="100%"
                loop={true}
                url="https://ftpeople.pl/wp-content/uploads/2025/04/Nagranie-z-ekranu-2025-04-17-o-10.28.26-1.mp4"
                playing={true}
                muted={true}
              />
            </div>
          </div>

          <div
            id="oneColFirst_column_additional2"
            className="twoCol_columnFirst"
            style={{ display: "block", boxSizing: "border-box" }}
          >
            <p className="pBlog" style={{ margin: "0", fontWeight: "600" }}>
              Najnowsze na blogu
            </p>
            {loading ? (
              <p className="pBlog">Ładowanie artykułów...</p>
            ) : (
              <div>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  target="_blank"
                  href={blog.length > 0 ? blog[0].link : ""}
                >
                  <p className="pBlog">
                    {decodeHtml(blog.length > 0 ? blog[0].title.rendered : "")}{" "}
                    <span
                      className="pBlog"
                      style={{
                        fontWeight: "600",
                        margin: "0",
                      }}
                    >
                      →
                    </span>
                  </p>
                </a>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  target="_blank"
                  href={blog.length > 0 ? blog[1].link : ""}
                >
                  <p className="pBlog">
                    {decodeHtml(blog.length > 0 ? blog[1].title.rendered : "")}{" "}
                    <span
                      className="pBlog"
                      style={{
                        fontWeight: "600",
                        margin: "0",
                      }}
                    >
                      →
                    </span>
                  </p>
                </a>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  target="_blank"
                  href={blog.length > 0 ? blog[2].link : ""}
                >
                  <p className="pBlog">
                    {decodeHtml(blog.length > 0 ? blog[2].title.rendered : "")}{" "}
                    <span
                      className="pBlog"
                      style={{
                        fontWeight: "600",
                        margin: "0",
                      }}
                    >
                      →
                    </span>
                  </p>
                </a>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  target="_blank"
                  href={blog.length > 0 ? blog[3].link : ""}
                >
                  <p className="pBlog">
                    {decodeHtml(blog.length > 0 ? blog[3].title.rendered : "")}{" "}
                    <span
                      className="pBlog"
                      style={{
                        fontWeight: "600",
                        margin: "0",
                      }}
                    >
                      →
                    </span>
                  </p>
                </a>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  target="_blank"
                  href={blog.length > 0 ? blog[4].link : ""}
                >
                  <p className="pBlog">
                    {decodeHtml(blog.length > 0 ? blog[4].title.rendered : "")}{" "}
                    <span
                      className="pBlog"
                      style={{
                        fontWeight: "600",
                        margin: "0",
                      }}
                    >
                      →
                    </span>
                  </p>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );

  const mobile = (
    <>
      <div style={{ display: "block" }}>
        <div className="formContainerFirst" style={{ width: "100%" }}>
          <div className="rowFirst">
            <div className="oneColFirst">
              <div id="twoCol_columnFirst_title" className="twoCol_columnFirst">
                <label style={{ marginBottom: "1vh", marginTop: "1vh" }}>
                  Wybierz bank, w którym masz zobowiązanie
                  <span className="requiredStar">*</span>
                </label>
              </div>
              <div id="oneColFirst_column" className="twoCol_columnFirst">
                <Select
                  className="currencySelect"
                  value={creditBank}
                  onChange={(e) => {
                    setCreditBank(e.value);
                  }}
                  options={bankOptions}
                  placeholder={creditBank ? creditBank : "Wybierz z listy..."}
                />
              </div>
              <div
                className="rowFirst"
                style={{
                  marginTop: "1vh",
                  width: "100%",

                  gap: "20px",
                  boxSizing: "border-box",
                }}
              >
                <div id="oneColFirst_column" style={{ width: "100%" }}>
                  <label style={{ marginBottom: "1vh", marginTop: "1vh" }}>
                    Kwota zobowiązania
                    <span className="requiredStar" style={{ fontSize: "3vw" }}>
                      *
                    </span>
                  </label>
                  <input
                    type="number"
                    id="creditAmmount"
                    name="creditAmmount"
                    placeholder="150000"
                    onFocus={focus}
                    value={creditAmmount}
                    onChange={(e) => {
                      if (creditAmmount === 0) {
                        window.gtag("event", "conversion", {
                          send_to: "AW-11435982333/exc0CLq8ydQaEP37jM0q",
                          value: 10.0,
                          currency: "PLN",
                        });
                      }
                      setCreditAmmount(e.target.value);
                    }}
                    onKeyPress={checkDigit}
                    style={{ width: "100%" }}
                  />
                </div>
                <div id="oneColFirst_column" style={{ width: "100%" }}>
                  <label style={{ marginBottom: "1vh", marginTop: "1vh" }}>
                    Data uruchomienia zobowiązania
                    <span className="requiredStar" style={{ fontSize: "3vw" }}>
                      *
                    </span>
                  </label>
                  <div style={{ width: "100%" }}>
                    <DatePicker
                      style={{ width: "100%" }}
                      closeOnScroll={true}
                      selected={new Date(creditDate)}
                      onChange={(e) => {
                        setCreditDate(e);
                      }}
                      dateFormat="yyyy-MM-dd"
                    />
                  </div>
                </div>
              </div>

              <div
                className="rowFirst"
                style={{
                  width: "100%",

                  gap: "20px",
                  boxSizing: "border-box",
                }}
              >
                <div id="oneColFirst_column" style={{ width: "100%" }}>
                  <label style={{ marginBottom: "1vh", marginTop: "1vh" }}>
                    Długość zobowiązania
                    <span className="requiredStar" style={{ fontSize: "3vw" }}>
                      *
                    </span>
                  </label>
                  <input
                    type="number"
                    id="creditAmmount"
                    name="creditAmmount"
                    placeholder="150000"
                    onFocus={focus}
                    value={creditLength}
                    onChange={(e) => {
                      setCreditLength(e.target.value);
                    }}
                    onKeyPress={checkDigit}
                    style={{ width: "100%" }}
                  />
                </div>
                <div id="oneColFirst_column" style={{ width: "100%" }}>
                  <label style={{ marginBottom: "1vh", marginTop: "1vh" }}>
                    Marża zobowiązania
                    <span className="requiredStar" style={{ fontSize: "3vw" }}>
                      *
                    </span>
                  </label>

                  <div style={{ width: "100%" }}>
                    <input
                      type="number"
                      id="creditAmmount"
                      name="creditAmmount"
                      placeholder="150000"
                      onFocus={focus}
                      value={creditMargin}
                      onChange={(e) => {
                        setCreditMargin(e.target.value);
                      }}
                      onKeyPress={checkDigit}
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              </div>

              <div
                className="rowFirst"
                style={{
                  marginTop: "1vh",
                  width: "100%",
                  display: "flex",
                  gap: "20px",
                  boxSizing: "border-box",
                }}
              >
                <div id="oneColFirst_column" style={{ width: "100%" }}>
                  <label style={{ marginBottom: "1vh", marginTop: "1vh" }}>
                    Prowizja instytucji udzielającej zobowiązania
                  </label>
                  <input
                    type="number"
                    id="creditAmmount"
                    name="creditAmmount"
                    placeholder="150000"
                    onFocus={focus}
                    value={creditComission}
                    onChange={(e) => {
                      setCreditComission(e.target.value);
                    }}
                    onKeyPress={checkDigit}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>

              <div
                className="rowFirst"
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: "1vh",
                }}
              >
                <p style={{ margin: 0, fontSize: "3vw" }}>
                  Przejdź dalej, aby wygenerować analizę roszczeń oraz zobaczyć
                  oferty kancelarii dostosowane do Twojej sprawy
                </p>
              </div>

              <div className="rowFirst" style={{ textAlign: "left" }}>
                <button
                  className="submitButtonFirstPage"
                  onClick={submitFirstForm}
                  style={{
                    fontSize: "3vw",
                    fontWeight: "600",
                    width: "100%",
                    marginTop: "1vh",
                  }}
                >
                  WYGENERUJ ANALIZĘ ZOBOWIĄZANIA I PORÓWNAJ KANCELARIE
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="descContainerFirst" style={{ width: "100%" }}>
          <div className="row">
            <p
              style={{
                margin: "0",
                paddingBottom: "10px",
                fontWeight: "600",
                fontSize: "3vw",
                textTransform: "uppercase",
                width: "100%",
                marginTop: "2vh",
              }}
            >
              Taki widok zobaczysz po przejściu dalej
            </p>
            <div>
              <ReactPlayer
                width="100%"
                height="100%"
                loop={true}
                url="https://ftpeople.pl/wp-content/uploads/2025/04/Nagranie-z-ekranu-2025-04-17-o-10.28.26-1.mp4"
                playing={true}
                muted={true}
              />
            </div>
          </div>

          <div
            id="oneColFirst_column_additional2"
            className="twoCol_columnFirst"
            style={{ display: "block", boxSizing: "border-box" }}
          >
            <p className="pBlog" style={{ margin: "0", fontWeight: "600" }}>
              Najnowsze na blogu
            </p>
            {loading ? (
              <p className="pBlog">Ładowanie artykułów...</p>
            ) : (
              <div>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  target="_blank"
                  href={blog.length > 0 ? blog[0].link : ""}
                >
                  <p className="pBlog">
                    {decodeHtml(blog.length > 0 ? blog[0].title.rendered : "")}{" "}
                    <span
                      className="pBlog"
                      style={{
                        fontWeight: "600",
                        margin: "0",
                      }}
                    >
                      →
                    </span>
                  </p>
                </a>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  target="_blank"
                  href={blog.length > 0 ? blog[1].link : ""}
                >
                  <p className="pBlog">
                    {decodeHtml(blog.length > 0 ? blog[1].title.rendered : "")}{" "}
                    <span
                      className="pBlog"
                      style={{
                        fontWeight: "600",
                        margin: "0",
                      }}
                    >
                      →
                    </span>
                  </p>
                </a>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  target="_blank"
                  href={blog.length > 0 ? blog[2].link : ""}
                >
                  <p className="pBlog">
                    {decodeHtml(blog.length > 0 ? blog[2].title.rendered : "")}{" "}
                    <span
                      className="pBlog"
                      style={{
                        fontWeight: "600",
                        margin: "0",
                      }}
                    >
                      →
                    </span>
                  </p>
                </a>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  target="_blank"
                  href={blog.length > 0 ? blog[3].link : ""}
                >
                  <p className="pBlog">
                    {decodeHtml(blog.length > 0 ? blog[3].title.rendered : "")}{" "}
                    <span
                      className="pBlog"
                      style={{
                        fontWeight: "600",
                        margin: "0",
                      }}
                    >
                      →
                    </span>
                  </p>
                </a>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  target="_blank"
                  href={blog.length > 0 ? blog[4].link : ""}
                >
                  <p className="pBlog">
                    {decodeHtml(blog.length > 0 ? blog[4].title.rendered : "")}{" "}
                    <span
                      className="pBlog"
                      style={{
                        fontWeight: "600",
                        margin: "0",
                      }}
                    >
                      →
                    </span>
                  </p>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <div className="mainContainerFirst">
        <div className="contentFirst">
          {showDetails ? (
            <SecondDetailPage
              close={closeDetail}
              goToThirdPage={props.goToThirdPage}
            />
          ) : (
            <>
              <div className="destkopView">{destkop}</div>
              <div className="mobileView">{mobile}</div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default FirstPage;
